import { Injectable } from '@angular/core'
import { forEach } from '@angular/router/src/utils/collection';
import { CookiesEnum } from '../dataModels';

@Injectable()
export class CookiesService {
    constructor() {
        this.defineCookies();
    }

    Cookies: CookieInterface[];

    private defineCookies() {
        this.Cookies = [];

        let _cookies = document.cookie.split(';');
        _cookies.forEach(cookie => {
            let newCookie: CookieInterface = new CookieInterface();

            newCookie.key = cookie.split('=')[0];
            newCookie.value = cookie.split('=')[1];
            this.Cookies.push(newCookie);
        })
    }

    getAllCookies() {
        return this.Cookies;
    }

    getCookieByKey(key: CookiesEnum) {
        let value = this.Cookies.find(cookie => cookie.key == CookiesEnum[key]);
        if (value)
            return value.value;
        else
            return null;
    }

}

class CookieInterface {
    key: string;
    value: string;
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/services/cookies.service.ts